import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { categories } from "@/mocks/categories";

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full border-t border-primary-800 bg-primary-900 text-primary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-megaphone-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">
              {site.tagline}。把手里的材料匿名放出，让线索被看见、被归档、被持续跟进。
            </p>
            <p className="mt-4 text-xs text-primary-300">{site.workTime}</p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">浏览线索</h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li>
                <Link to="/clues" className="transition-colors hover:text-accent-400">
                  全部线索归档
                </Link>
              </li>
              {categories.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="transition-colors hover:text-accent-400"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">参与其中</h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li>
                <Link to="/submit" className="transition-colors hover:text-accent-400">
                  匿名提交爆料
                </Link>
              </li>
              <li>
                <Link to="/categories" className="transition-colors hover:text-accent-400">
                  主题分类导航
                </Link>
              </li>
              <li>
                <Link to="/faq" className="transition-colors hover:text-accent-400">
                  投稿常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  平台定位与原则
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li className="flex items-start gap-2">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-mail-line text-base text-accent-400" />
                </span>
                <span className="break-all">{site.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-inbox-archive-line text-base text-accent-400" />
                </span>
                <span className="break-all">投稿专用：{site.tipEmail}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-time-line text-base text-accent-400" />
                </span>
                <span>{site.reviewCycle}</span>
              </li>
            </ul>
            <Link
              to="/submit"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-label font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-send-plane-line" />
              匿名爆料入口
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {site.name}. 内容为投稿人陈述与公开资料整理，不代表平台结论。
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/faq" className="transition-colors hover:text-accent-400">
              内容原则
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              平台说明
            </Link>
            <Link to="/contact" className="transition-colors hover:text-accent-400">
              更正与反馈
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;